import { render, staticRenderFns } from "./xian.vue?vue&type=template&id=5a1f5cdc&scoped=true&"
import script from "./xian.vue?vue&type=script&lang=js&"
export * from "./xian.vue?vue&type=script&lang=js&"
import style0 from "./xian.vue?vue&type=style&index=0&id=5a1f5cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f5cdc",
  null
  
)

export default component.exports